<template>
  <div style="background-color: white">
    <div class="has-background-gcc" style="text-align: center">
      <img src="../../../../public/SOA/1. Banner - Inicio.png" />
    </div>

    <div class="columns is-centered mt-0">
      <div class="column is-9">
        <!--solicitudes-->
        <div class="section pt-1" style="background-color: white">
          <!-- Separador -->
          <hr class="solid" />
          <div class="columns is-multiline is-centered">
            <div v-if="canCreateRequest" class="column">
              <a
                class="button is-customgrey is-border-light-grey is-large is-fullwidth"
                :href="new_requests_path"
              >
                <span>
                  <i class="fas fa-file-alt mx-2"></i>
                </span>
                <span> Iniciar una solicitud </span>
              </a>
            </div>
            <div class="column">
              <a
                class="button is-customgrey is-border-light-grey is-large is-fullwidth"
                :href="my_requests_path"
              >
                <span>
                  <i class="fas fa-file-invoice mx-2"> </i>
                </span>
                <span> Mis Solicitudes</span>
              </a>
            </div>
            <!--                        <div class="column is-one-third">-->
            <!--                            <a class="button is-customgrey is-large is-fullwidth" :href="search_requests_path">-->
            <!--                      <span>-->
            <!--                          <i class="fas fa-search mx-2"></i>-->
            <!--                      </span>-->
            <!--                                <span>-->
            <!--                          Buscar Solicitud-->
            <!--                      </span>-->
            <!--                            </a>-->
            <!--                        </div>-->
          </div>

        </div>

        <!--Carrusel de imagenes-->

        <b-carousel :pause-info="false">
          <b-carousel-item v-for="(item, i) in items" :key="i">
            <b-image class="image" :src="item.src"></b-image>
          </b-carousel-item>
        </b-carousel>
        <!--mapa-->

        <div class="mt-5" align="center">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3329.571353058175!2d-70.6832777!3d-33.4474356!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662c560ac6e81ff%3A0x1db726713bd1c3d7!2sFacultad%20de%20Ingenier%C3%ADa%20USACH!5e0!3m2!1sen!2scl!4v1652986186944!5m2!1sen!2scl" 
            width="600" 
            height="450" 
            style="border:0;" 
            allowfullscreen="" 
            loading="lazy" 
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>

        </div>
      </div>
    </div>

    <!-- Footer -->

    <div style="background-color: #003b71" align="center">
      <img src="../../../../public/logo_sin_texto.png" />
      <div>
        <a href="https://www.fing.usach.cl/" target="_blank">
          <h1
            class="is-size-6 has-text-warning has-text-centered is-family-secondary has-text-weight-bold"
          >
            WEB OFICIAL FING USACH | Entra aquí
          </h1>
        </a>
        <br />
      </div>
    </div>
    <div class="has-background-gcc" align="center">
      <br />
      <h1
        class="is-size-6 has-text-white has-text-centered is-family-secondary"
      >
        Universidad de Santiago de Chile. Avenida Libertador Bernardo O'Higgins
        nº 3363. Estación Central. Santiago. Chile.
      </h1>
      <a href="https://www.usach.cl/contacto" target="_blank">
        <h1
          class="is-size-6 has-text-secondary has-text-centered is-family-secondary has-text-weight-bold"
        >
          Oficina de Informaciones, Reclamos y Sugerencias (OIRS)
        </h1>
      </a>
      <br />
    </div>

    <b-modal
      v-model="isModalPaymentInfoOpen"
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal
      width="90%"
    >
      <template #default="props">
        <PaymentInfoModal @close="props.close"></PaymentInfoModal>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import Youtube from "../Tools/Youtube";
import PaymentProgramInfo from "../RequestType/PaymentProgramInfo.vue";
import PaymentAllInfo from "../RequestType/PaymentAllInfo.vue";

export default {
  name: "GccHome",
  components: {
    PaymentInfoModal: () => import("../RequestType/PaymentInfoModal.vue"),
    Youtube,
    PaymentProgramInfo,
    PaymentAllInfo,
  },
  props: ["canListRequests", "canCreateRequest"],
  data: function () {
    return {
      list_requests_path: "/requests",
      faq_path: "/gcc/faq",
      contact_path: "/gcc/contact_us",
      new_requests_path: "/soa/request_types",
      search_requests_path: "/requests/search",
      my_requests_path: "/requests/my_requests",
      isModalSelectRequestTypeActive: false,
      requestTypes: ["", "Nombramiento"],
      selectedRequestType: null,
      isModalPaymentInfoOpen: false,
      items: [
        {
          src: require("../../../../public/gsd/home_student_images/carousel_images/Imagen1.png"),
        },
        {
          src: require("../../../../public/gsd/home_student_images/carousel_images/Imagen2.png"),
        },
        {
          src: require("../../../../public/gsd/home_student_images/carousel_images/Imagen3.png"),
        },
        {
          src: require("../../../../public/gsd/home_student_images/carousel_images/Imagen4.png"),
        },
        {
          src: require("../../../../public/gsd/home_student_images/carousel_images/Imagen5.png"),
        },
      ],
    };
  },

  created() {
    document.title = "SOA | Inicio";

    this.getRequestTypes();
  },

  methods: {
    async getRequestTypes() {
      await axios
        .get("/request_types.json")
        .then((response) => {
          this.requestTypes = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.requestTypes = [];
        });
    },

    debug() {},
    listRequests() {
      //This functions is called when button "Listar Solicitudes" is pressed
      //do something
      //call backend
    },
    openModalSelectRequestType() {
      //This functions is called when button "crear Solicitud" is pressed
      //do something
      this.isModalSelectRequestTypeActive = true;
    },
    redirectToNewRequest() {
      //This functions is called when button "Buscar Solicitud" is pressed
      if (this.selectedRequestType == null) {
        // There's no type request selected
        console.log("No se ha seleccionado Tipo de Solicitud");
      } else {
        window.location.href = "/requests/request_types";
      }
    },
  },
};
</script>

<style>
.map-responsive {
}

.map-responsive iframe {
}

.responsive {
  width: 100%;
  height: auto;
}

/* Solid border */
hr.solid {
  border-top: 2px solid #bbb;
  width: 100%;
}
</style>
